const OMITTED = new Set(["bounds", "page", "per_page", "slots_ui_start_date"]);

/** Returns the coordinate feed's filter params without viewport, pagination or slot-date scoping. */
export function microPinParams(params = {}) {
  return Object.fromEntries(Object.entries(params).filter(([key]) => !OMITTED.has(key)));
}

function sorted(value) {
  if (Array.isArray(value)) {
    return value.map(sorted);
  }
  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.keys(value)
        .sort()
        .map((key) => [key, sorted(value[key])]),
    );
  }
  return value == null ? "" : String(value);
}

/**
 * Returns a stable filter key while preserving meaningful array ordering. Values compare by their
 * query-string form: `{ distance: 10 }` and `{ distance: "10" }` share a key.
 */
export function microPinKey(params) {
  return JSON.stringify(sorted(microPinParams(params)));
}
